import { BlogList } from "@components/blog/BlogList";
import { PageSEO } from "@components/blog/SEO";
import siteMetadata from "@/data/siteMetadata";
import { getAllFilesFrontMatter } from "@/lib/mdx";
import BlogHero from "@components/blog/BlogHero";
import { FAQSection, Question } from "components/FAQSection";
import { CTASection } from "components/platform/CTASection";
import Layout from "components/platform/Layout";
import { GetStaticProps, InferGetStaticPropsType } from "next";
import { ComponentProps, ReactElement } from "react";

export const POSTS_PER_PAGE = 5;

export const getStaticProps: GetStaticProps<{
  posts: ComponentProps<typeof BlogList>["posts"];
  initialDisplayPosts: ComponentProps<typeof BlogList>["initialDisplayPosts"];
  pagination: ComponentProps<typeof BlogList>["pagination"];
}> = async () => {
  const allPosts = await getAllFilesFrontMatter("blog");
  const posts = allPosts.filter((post) => post.listed !== false);

  const initialDisplayPosts = posts.slice(0, POSTS_PER_PAGE);
  const pagination = {
    currentPage: 1,
    totalPages: Math.ceil(posts.length / POSTS_PER_PAGE),
  };

  return { props: { initialDisplayPosts, posts, pagination } };
};

type Props = InferGetStaticPropsType<typeof getStaticProps>;

const Blog: NextPageTypes.NextPageWithLayout<Props> = ({
  posts,
  initialDisplayPosts,
  pagination,
}: Props) => {
  return (
    <>
      <PageSEO
        title={`Blog - ${siteMetadata.title}`}
        description={siteMetadata.description}
      />
      <BlogHero />
      <main className="bg-gray-100 ">
        <div className="container-xl">
          <div className="py-48 md:py-100 lg:px-56 ">
            <div className="">
              <BlogList
                posts={posts}
                initialDisplayPosts={initialDisplayPosts}
                pagination={pagination}
              />
            </div>
          </div>
        </div>
        <CTASection className="" />
      </main>
    </>
  );
};

Blog.getLayout = function getLayout(page: ReactElement) {
  return <Layout noTags>{page}</Layout>;
};

export default Blog;
